module.exports = __webpack_public_path__ + "static/img/color.38446167.jpg";